import React, { useCallback } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { saveBillingInfo } from '../../../../../app/page/subscription/subscription.actions';
import { subscriptionPageSelectors } from '../../../../../app/page/subscription/subscription.selectors';
import { IBillingInfoInput } from '../../../../../app/page/subscription/subscription.types';
import { SubmitButton } from '../../../common/forms/SubmitButton';
import { billingCountryOption, billingFieldValue, billingStateOption, BillingInfoFields } from './BillingInfoFields';

export const BillingInfo = () => {
  const dispatch = useDispatch();
  const billingInfo = useSelector(subscriptionPageSelectors.selectBillingInfo);
  const savedCountry = billingCountryOption(billingInfo?.country ?? '');
  const savedState =
    savedCountry?.value === 'US' ? billingStateOption(billingInfo?.state ?? '') ?? '' : billingInfo?.state ?? '';
  const formProps = useForm({
    defaultValues: {
      address: billingInfo?.address ?? '',
      city: billingInfo?.city ?? '',
      state: savedState,
      zipCode: billingInfo?.zipCode ?? '',
      country: savedCountry ?? '',
    },
  });

  const onSubmit = useCallback(
    (formData: IBillingInfoInput) => {
      dispatch(
        saveBillingInfo({
          address: formData.address.trim(),
          city: formData.city.trim(),
          state: billingFieldValue(formData.state),
          zipCode: formData.zipCode.trim(),
          country: billingFieldValue(formData.country),
        }),
      );
    },
    [dispatch],
  );

  return (
    <div className="col px-0">
      <div className="field-container px-2 mb-5">
        <div className="panel theme-gradient-2 py-1 px-2 flex aic mb-3">
          <h2 className="f-14 white bold">BILLING INFO</h2>
        </div>
        <FormProvider {...formProps}>
          <form id="billing-info-form" className="topic-form" onSubmit={formProps.handleSubmit(onSubmit)}>
            <BillingInfoFields
              address={billingInfo?.address ?? ''}
              city={billingInfo?.city ?? ''}
              state={billingInfo?.state ?? ''}
              zipCode={billingInfo?.zipCode ?? ''}
              country={billingInfo?.country ?? ''}
            />
            <div className="col-12">
              <SubmitButton apiKey="saveBillingInfo" formName="billing-info-form" text="Save" />
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};
